<p class="heading">
  <strong *ngIf="id">{{'pages.common.buttons.update' |
    translate}}&nbsp;{{'pages.branches.branchDetail.input.'+dialogType | translate}}</strong>
  <strong *ngIf="!id">{{'pages.common.buttons.add' | translate}}&nbsp;{{'pages.branches.branchDetail.input.'+dialogType
    | translate}}</strong>
  <mat-icon mat-dialog-close>close</mat-icon>
</p>
<form (ngSubmit)="submitForm('timeSlotHolidayForm')" *ngIf="dialogType=='openingTimesPublicHolidaysDelivery' ||
 dialogType=='openingTimesPublicHolidaysPickup'" [formGroup]="timeSlotHolidayForm">
  <div class="frm-box-outer">
    <div class="frm-box">
      <div class="form-group">
        <label class="form-label">{{'pages.branches.timeSlotDialog.input.title' | translate}}</label>
        <input type="text" class="form-control" formControlName="title">
        <div class="feedback"
          *ngIf="timeSlotHolidayForm.controls['title'].invalid && (timeSlotHolidayForm.controls['title'].dirty || timeSlotHolidayForm.controls['title'].touched)">
        </div>
        <div
          *ngIf="timeSlotHolidayForm.controls['title']?.errors && (timeSlotHolidayForm.controls['title'].dirty || timeSlotHolidayForm.controls['title'].touched)"
          class="feedback">
          <div *ngIf="timeSlotHolidayForm.controls['title'].errors.required">
            {{'pages.branches.timeSlotDialog.inputValidation.title.required' | translate}}</div>
          <div *ngIf="timeSlotHolidayForm.controls['title'].errors.pattern">
            {{'pages.branches.timeSlotDialog.inputValidation.title.whitespace' | translate}}</div>
        </div>
      </div>
      <div class="row topAndmargin">
        <div class="col">
          <label>{{'pages.branches.timeSlotDialog.input.date' | translate}}</label>
          <mat-form-field class="form-control datePicker2">
            <input disabled matInput [matDatepicker]="picker1" [min]="today" class="form-control bg-transparent"
              formControlName="date">
            <mat-datepicker-toggle disabled="false" matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker disabled="false" #picker1></mat-datepicker>
          </mat-form-field>
          <div *ngIf="timeSlotHolidayForm.controls['date']?.errors" class="feedback">
            <div *ngIf="timeSlotHolidayForm.controls['date'].errors.required">
              {{'pages.branches.timeSlotDialog.inputValidation.date' | translate}}</div>
          </div>
        </div>
        <div class="col">
          <label>{{'pages.branches.timeSlotDialog.input.closeDay' | translate}}</label>
          <mat-checkbox formControlName="closeDay" (change)="checkCheckBoxvalue($event)"
            class="form-control custom-frame" style="right: 87px;">
          </mat-checkbox>
        </div>
      </div>
      <div class="row topAndmargin" *ngIf="!showHideTime">
        <label class="form-label lable-open-on">{{'pages.branches.timeSlotDialog.input.openOn' | translate}}</label>
      </div>
      <app-day-time-slot *ngIf="!showHideTime" formControlName="slot"></app-day-time-slot>

      <div class="form-group">
        <button type="submit" class="fill-button" mat-flat-button> {{'pages.common.buttons.save' | translate}} </button>
        <span *ngIf="dialogType=='openingTimesPublicHolidaysDelivery'">
          <button type="button" class="outline-button" mat-stroked-button
            (click)="deletePublicHoliday('openingTimesPublicHolidaysDelivery',data.publicHolidayId)"
            *ngIf="data.publicHolidayId">
            {{'pages.common.buttons.delete' | translate}} </button>
        </span>
        <span *ngIf="dialogType=='openingTimesPublicHolidaysPickup'">
          <button type="button" class="outline-button" mat-stroked-button
            (click)="deletePublicHoliday('openingTimesPublicHolidaysPickup',data.publicHolidayId)"
            *ngIf="data.publicHolidayId">
            {{'pages.common.buttons.delete' | translate}} </button>
        </span>

      </div>
    </div>
  </div>
</form>

<form [formGroup]="timeSlotForm" (ngSubmit)="submitForm('istimeSlotForm')" *ngIf="dialogType=='openingTimesDeliveryStandard' || dialogType=='openingTimesPickupStandard' ||
dialogType=='openingTimesDeliveryAlternative' || dialogType=='openingTimesPickupAlternative'">
  <div class="frm-box-outer">
    <div class="frm-box">
      <div class="form-group">
        <label class="form-label">{{'pages.branches.timeSlotDialog.input.title' | translate}}</label>
        <input type="text" class="form-control" formControlName="title">
        <div class="feedback"
          *ngIf="timeSlotForm.controls['title'].invalid && (timeSlotForm.controls['title'].dirty || timeSlotForm.controls['title'].touched)">
        </div>
        <div
          *ngIf="timeSlotForm.controls['title']?.errors && (timeSlotForm.controls['title'].dirty || timeSlotForm.controls['title'].touched)"
          class="feedback">
          <div *ngIf="timeSlotForm.controls['title'].errors.required">
            {{'pages.branches.timeSlotDialog.inputValidation.title.required' | translate}}</div>
          <div *ngIf="timeSlotForm.controls['title'].errors.pattern">
            {{'pages.branches.timeSlotDialog.inputValidation.title.whitespace' | translate}}</div>
        </div>
      </div>
      <label class="form-label lable-open-on">{{'pages.branches.timeSlotDialog.input.openOn' | translate}}</label>
      <mat-tab-group mat-align-tabs="center">
        <mat-tab label="{{'pages.branches.timeSlotDialog.input.mon' | translate}}"
          [labelClass]="timeSlotForm.controls['monday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
          <app-day-time-slot formControlName="monday"></app-day-time-slot>
        </mat-tab>

        <mat-tab label="{{'pages.branches.timeSlotDialog.input.tue' | translate}}"
          [labelClass]="timeSlotForm.controls['tuesday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
          <app-day-time-slot formControlName="tuesday">
          </app-day-time-slot>
        </mat-tab>

        <mat-tab label="{{'pages.branches.timeSlotDialog.input.wed' | translate}}"
          [labelClass]="timeSlotForm.controls['wednesday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
          <app-day-time-slot formControlName="wednesday">
          </app-day-time-slot>
        </mat-tab>

        <mat-tab label="{{'pages.branches.timeSlotDialog.input.thu' | translate}}"
          [labelClass]="timeSlotForm.controls['thursday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
          <app-day-time-slot formControlName="thursday">
          </app-day-time-slot>
        </mat-tab>

        <mat-tab label="{{'pages.branches.timeSlotDialog.input.fri' | translate}}"
          [labelClass]="timeSlotForm.controls['friday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
          <app-day-time-slot formControlName="friday">
          </app-day-time-slot>
        </mat-tab>

        <mat-tab label="{{'pages.branches.timeSlotDialog.input.sat' | translate}}"
          [labelClass]="timeSlotForm.controls['saturday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
          <app-day-time-slot formControlName="saturday">
          </app-day-time-slot>
        </mat-tab>

        <mat-tab label="{{'pages.branches.timeSlotDialog.input.sun' | translate}}"
          [labelClass]="timeSlotForm.controls['sunday'].invalid ? 'invalid-form' : ''" [disabled]="weekdays">
          <app-day-time-slot formControlName="sunday">
          </app-day-time-slot>
        </mat-tab>

      </mat-tab-group>
      <div class="form-group">
        <button type="submit" class="fill-button" [disabled]="!timeSlotForm.valid" mat-flat-button>
          {{'pages.common.buttons.save' | translate}} </button>
        <button type="button" class="outline-button" mat-stroked-button mat-dialog-close>
          {{'pages.common.buttons.cancel' | translate}} </button>
      </div>
    </div>
  </div>
</form>
<!-- {{ timeSlotForm.value | json }} -->